import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { ListItem, ListItemButton, ListItemText, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

import { selectFormType } from 'store/forms/selectors';

import { getStyles } from '../DynamicField.styles';

import CategoryWrapper from './CategoryWrapper';
import { ADDED_FIELD_LABEL } from './DynamicFieldItemsList.constants';

const defaultAddedValues = [];

const Categories = ({
  categories,
  depth = 0,
  chosenOptionValue,
  chosenElementRef,
  onSelectDynamicField,
  onCollapseClick,
  timeout,
  hasSearch,
  addedValues = defaultAddedValues,
}) => {
  const theme = useTheme();
  const classes = getStyles(theme, { depth });

  const formType = useSelector(selectFormType);

  return (
    <>
      {categories?.map(category => {
        return (
          <CategoryWrapper
            className="p-0"
            depth={depth}
            hasFields={!!category.fields.length}
            hasSearch={hasSearch}
            key={category.uniqueId ?? category.title}
            timeout={timeout}
            title={category.title}
            onCollapseClick={onCollapseClick}
          >
            {category.fields
              .filter(i => !i.allowedFormTypes || i.allowedFormTypes.includes(formType))
              .map(({ title, label, type, value, ignoreUserDefinedStyles }) => {
                return (
                  <ListItem disablePadding key={value}>
                    <ListItemButton
                      data-ignore-user-defined-styles={ignoreUserDefinedStyles}
                      data-label={label}
                      data-title={title}
                      data-type={type}
                      data-value={value}
                      ref={chosenOptionValue === value ? chosenElementRef : undefined}
                      selected={chosenOptionValue === value}
                      sx={classes.listItem}
                      onClick={onSelectDynamicField}
                    >
                      <ListItemText
                        primary={title}
                        secondary={addedValues.includes(value) ? ADDED_FIELD_LABEL : null}
                        sx={classes.listItemText}
                        title={title}
                      />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            {!!category.categories.length && (
              <Categories
                addedValues={addedValues}
                categories={category.categories}
                chosenElementRef={chosenElementRef}
                chosenOptionValue={chosenOptionValue}
                depth={depth + 1}
                hasSearch={hasSearch}
                onSelectDynamicField={onSelectDynamicField}
              />
            )}
          </CategoryWrapper>
        );
      })}
    </>
  );
};

Categories.propTypes = {
  categories: PropTypes.array.isRequired,
  hasSearch: PropTypes.bool.isRequired,
  chosenElementRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  chosenOptionValue: PropTypes.string.isRequired,
  onSelectDynamicField: PropTypes.func.isRequired,
  depth: PropTypes.number,
  timeout: PropTypes.number,
  addedValues: PropTypes.arrayOf(PropTypes.string),
  onCollapseClick: PropTypes.func,
};

export default memo(Categories);
